import { Tag, TagLabel, TagLeftIcon, TagProps } from "@chakra-ui/react";
import { IconType } from "react-icons";

type Props = {
  active: boolean;
  icon?: IconType;
} & TagProps;

export const DraftStatusTag = ({ active, icon, ...rest }: Props) => {
  return (
    <Tag size="md" colorScheme={active ? "green" : "gray"} {...rest}>
      {icon && <TagLeftIcon as={icon} />}
      <TagLabel>{active ? "Publicado" : "Oculto"}</TagLabel>
    </Tag>
  );
};
